export const UNASSIGNED_EPIC_ID = 'unassigned' as const;
export const DEBOUNCE_MILLISECONDS = 300;
export const jiraReleasesExperimentalApiHeader = {
	'X-ExperimentalApi': 'jira-releases-v0',
} as const;
export const SMALL_BROWSER_BREAKPOINT = 1280;

// For background on this, see:
// * https://jdog.jira-dev.com/browse/RLSS-226
// * https://hello.atlassian.net/wiki/spaces/PF/pages/757921226/How+to+handle+bad+historical+deployment+data+in+Grapevine
export const BAD_DEPLOYMENTS_DATA_END_DATE = new Date('2020-04-01T00:00:00');

export const DATE_FORMAT_DASH = 'yyyy-MM-dd'; // this matches @atlaskit/calendar format

export const DATE_FORMAT_SLASH = 'yyyy/MM/dd'; // date format that is shown to users

export const DATE_FORMAT_SLASH_PLACEHOLDER = 'YYYY/MM/DD';

// top filters
export const ENVIRONMENT = 'ENVIRONMENT' as const;
export const VERSION = 'VERSION' as const;
export const EPIC = 'EPIC' as const;
export const ISSUE_TYPE = 'ISSUE_TYPE' as const;

export const DEFAULT_VISIBLE_USERS = 5;
export const MIN_VISIBLE_USERS = 2;
export const USER_AVATAR_WIDTH = 30;
export const MIN_FILTER_BAR_WIDTH = 405;
export const MIN_SEARCH_INPUT_WIDTH = 120;
